// The server accepts exactly these as reactions (MessageReactions::ALLOWED).
export const QUICK_REACTIONS = ['👍', '❤️', '😂', '🙏'];

export const EMOJI_GROUPS = {
  smileys: ['😀', '😃', '😄', '😁', '😊', '🙂', '😉', '😅', '😂', '🥲', '🥰', '😍', '😘', '😋', '😎', '🤩',
    '🤔', '🙃', '😐', '😴', '😢', '😭', '😮', '😱', '😤', '🤗', '😇', '🤝'],
  gestures: ['👍', '👎', '👌', '✌️', '🤞', '🙏', '👏', '🙌', '💪', '👋', '☝️', '✍️', '🤙', '🫶'],
  hearts: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🤍', '💔', '✨', '🌟', '⭐', '🎉', '🎊', '🔥'],
  everyday: ['🏠', '🚗', '🚙', '🔑', '📄', '📎', '📅', '⏰', '💰', '💳', '🧾', '📞', '📧', '☂️', '🌧️',
    '⚠️', '✅', '❌', '🐶', '🐱', '🧳', '✈️', '🏥', '🚑', '🛠️', '🌳', '👨‍👩‍👧'],
};

export const ALL_EMOJI = [...new Set([...QUICK_REACTIONS, ...Object.values(EMOJI_GROUPS).flat()])];

const hex = (emoji) => [...emoji].map((c) => c.codePointAt(0).toString(16)).join('-');

const toPicker = (list) => list.map((emoji) => ({ n: [emoji], u: hex(emoji) }));

export const PICKER_GROUPS = Object.fromEntries(
  Object.entries(EMOJI_GROUPS).map(([key, list]) => [key, toPicker(list)]),
);

// The library's own "recent" lives in indexedDB, is shared with OmniChat's
// full emoji set and can offer emoji the server refuses as reactions.
export const PICKER_DISABLED = ['recent', 'smileys_people', 'animals_nature', 'food_drink', 'activities', 'travel_places', 'objects', 'symbols', 'flags'];

const RECENT_KEY = 'messages.recentEmoji';
const RECENT_MAX = 14;
const RECENT_SEED = ['👍', '🙏', '😊', '❤️', '🎉', '👏'];
let recentInMemory = null;

/** What this person picked, newest first — or a starter set before they have picked anything. */
export const recentEmoji = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(RECENT_KEY));
    const usable = Array.isArray(stored) ? stored.filter((emoji) => ALL_EMOJI.includes(emoji)) : [];
    if (usable.length) return usable.slice(0, RECENT_MAX);
  } catch (e) {
    // Unreadable storage falls back to this visit's list.
  }

  return recentInMemory ?? RECENT_SEED;
};

export const rememberEmoji = (emoji) => {
  recentInMemory = [emoji, ...recentEmoji().filter((e) => e !== emoji)].slice(0, RECENT_MAX);
  try {
    window.localStorage.setItem(RECENT_KEY, JSON.stringify(recentInMemory));
  } catch (e) {
    // Kept in memory only.
  }
};

export const pickerGroups = () => ({ picked: toPicker(recentEmoji()), ...PICKER_GROUPS });

export const PICKER_GROUP_NAMES = { picked: 'Recent' };

const EMOJI_ONLY = /^(?:[\p{Extended_Pictographic}\u{FE0F}\u{200D}\u{1F3FB}-\u{1F3FF}\u{1F1E6}-\u{1F1FF}]|\s)+$/u;

const graphemes = (text) => [...new Intl.Segmenter('en', { granularity: 'grapheme' }).segment(text)].length;

/** One to three emoji and nothing else is sent big, without a bubble. */
export const isJumbo = (text) => {
  const s = (text || '').trim();

  return s !== '' && EMOJI_ONLY.test(s) && graphemes(s.replace(/\s+/g, '')) <= 3;
};
